/* eslint-disable react-hooks/exhaustive-deps */
import { useGlobalStore } from "@/store/GlobalStore";
import { useTranslation } from "react-i18next";
import { Level, MemberCard, FoxNormalRechargeWrapper, Price } from "./atom";
import { UserLevel } from "project-config/constants";
import { useFoxTopUpStore } from "../../store";
import { useEffect, useState } from "react";
import { FoxCommonCardListWrapper } from "../../atom";
import CheckIcon from "@/assets/icons/topup/check";
import { BindHangTags } from "@/components/top-up/types";
import { AnimationVipDesc } from "../../constants/fox-balance-info";
import { accSub } from "project-config/utils/acc";

export function FoxNormalRecharge() {
  const { t } = useTranslation("topup");
  const { currencySymbol, userInfo, userCumulative } = useGlobalStore();
  const HangTags = useFoxTopUpStore((state) => state.HangTags);
  const isCheckCard = useFoxTopUpStore((state) => state.isCheckCard);
  const { setter: setFoxTopUpStore } = useFoxTopUpStore();
  const recharge = (rechargeInfo: BindHangTags) => {
    const v = rechargeInfo.usdCumulative;
    return Number(accSub(v, userCumulative).toFixed(2));
  };
  const [checkCardPrice, setCheckCardPrice] = useState(0);

  const getRechargeAmount = (rechargeInfo: BindHangTags) => {
    if (!userInfo) return 1;
    if (userInfo?.level === UserLevel.Diamond)
      return rechargeInfo.animationNum || 0;
    return recharge(rechargeInfo) < 0 && userInfo.level < rechargeInfo.level
      ? 1
      : recharge(rechargeInfo);
  };

  const cardActive = (val?: number) => {
    let currentClassName = "";
    if (userInfo?.level === UserLevel.Diamond) currentClassName = "isDiamond";
    if (checkCardPrice === val && isCheckCard)
      currentClassName = `${currentClassName} active`;
    return currentClassName;
  };

  useEffect(() => {
    if (!HangTags.length) return;
    const price =
      userInfo?.level === UserLevel.Diamond
        ? HangTags[0].animationNum
        : recharge(HangTags[0]);
    setCheckCardPrice(price || 0);
    setFoxTopUpStore({
      amount: getRechargeAmount(HangTags[0]), // 防止在后管强制降低vip等级
      isCheckCard: true,
    });
  }, [HangTags]);

  return (
    <FoxNormalRechargeWrapper>
      <FoxCommonCardListWrapper>
        {HangTags.map((item) => {
          const rechargeAmount =
            userInfo?.level === UserLevel.Diamond
              ? item.animationNum
              : recharge(item);
          return (
            <MemberCard
              key={item.id}
              onClick={() => {
                setCheckCardPrice(rechargeAmount || 0);
                setFoxTopUpStore((state) => {
                  state.amount = getRechargeAmount(item); // 防止在后管强制降低vip等级
                  state.isCheckCard = true;
                  state.checkedRadioId = 0;
                });
              }}
              className={cardActive(rechargeAmount)}
            >
              {userInfo?.level !== UserLevel.Diamond && (
                <Level className={cardActive(rechargeAmount)}>
                  {t("upgrade_section_level")}&nbsp;
                  {t(AnimationVipDesc[item.level])}
                </Level>
              )}
              <Price className={cardActive(rechargeAmount)}>
                <div>
                  <span className="unit">{currencySymbol}</span>
                  <span>{rechargeAmount}</span>
                </div>
                {cardActive(rechargeAmount).includes("active") && (
                  <CheckIcon fill="#F3512B" />
                )}
              </Price>
            </MemberCard>
          );
        })}
      </FoxCommonCardListWrapper>
    </FoxNormalRechargeWrapper>
  );
}
